import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import { PhotoContext } from '../../context/PhotoProvider';
import { useNavigate } from 'react-router';
import { APP_ROUTES } from '../../constants/appRoutes';
import Block from '../../components/Block';
import { Colors } from '../../constants/colorMap';
import { ProductTypes } from '../../types/enums';
import api from '../../services/api';
import { SizeInfo } from '../Instruction';
import { API_ROUTES } from '../../constants/api_routes';
import mosaicBackground from '../../assets/mosaicBackground.png';
import embroideryBackground from '../../assets/embroideryBackground.png';
import mosaicMobileBackground from '../../assets/mosaicMobileBackground.png';
import embroideryMobileBackground from '../../assets/embroideryMobileBackground.png';

type SizeType = {
  size: string;
  color: Colors;
  value: string;
  aspect: number;
};

const routesMap = {
  [ProductTypes.PAINTING]: {
    next: APP_ROUTES.UPLOAD_PAINTING_PHOTO,
    back: APP_ROUTES.PAINTING,
  },
  [ProductTypes.MOSAIC]: {
    next: APP_ROUTES.HOW_TO_CHOOSE_PHOTO,
    back: APP_ROUTES.MAIN_PAGE,
  },
  [ProductTypes.EMBROIDERY]: {
    next: APP_ROUTES.HOW_TO_CHOOSE_EMBROIDERY_PHOTO,
    back: APP_ROUTES.MAIN_PAGE,
  },
  [ProductTypes.DOT_PAINTING]: {
    next: APP_ROUTES.HOW_TO_CHOOSE_DOT_PAINTING_PHOTO,
    back: APP_ROUTES.DOT_PAINTING,
  },
};

const fetchSizesInfo = async (productType: ProductTypes) => {
  const sizesRaw: SizeInfo[] = await api({
    URL: API_ROUTES.INFO_SIZES,
    options: {
      method: 'POST',
      body: { type: productType },
    },
  });

  const colors = ['pink', 'blue', 'green'];
  const sizes: {
    size: string;
    color: Colors;
    value: string;
    aspect: number;
  }[] = sizesRaw.map((item: SizeInfo, index: number) => {
    return {
      size: item.label,
      color: colors[index] as Colors,
      value: item.size,
      aspect: item.aspect,
    };
  });

  return sizes;
};

const ChooseSizeDiamondPhotoMosaic = () => {
  const { setSize, setAspect } = useContext(PhotoContext);
  const navigate = useNavigate();
  const { productType } = useContext(PhotoContext);
  const { t } = useTranslation();

  const isMosaic = productType === 'mosaic';
  const handleClick = (size: string, aspect: number) => {
    setSize(size);
    setAspect(aspect);
    navigate(routesMap[productType].next);
  };

  const [sizes, setSizes] = useState<SizeType[]>([]);
  useEffect(() => {
    const fetchMyData = async () => {
      const sizes = await fetchSizesInfo(productType);
      setSizes(sizes);
    };
    fetchMyData();
  }, [productType]);

  const isMobile = window.innerWidth <= 1000;

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t('Select the size you need')}</h1>
      <h4 className={styles.subTitle}>
        {t('We will provide you with three design options for free')}
      </h4>
      {sizes.map((size, index) => {
        return (
          <Block
            key={index}
            size="small"
            type={productType}
            color={size.color}
            text={`${t('Size')}: ${size.value} ${t('cm')}`}
            buttonAction={() => handleClick(size.value, size.aspect)}
          />
        );
      })}
      <Block
        size="large"
        buttonText="Get Instruction"
        customBackground={
          isMobile
            ? isMosaic
              ? `url(${mosaicMobileBackground})`
              : `url(${embroideryMobileBackground})`
            : isMosaic
            ? `url(${mosaicBackground})`
            : `url(${embroideryBackground})`
        }
        text={
          isMosaic
            ? 'Already have the Diamond Painting Kit?'
            : 'Already have the Embroidery Kit?'
        }
        buttonAction={() => navigate(APP_ROUTES.INSTRUCTION)}
      />
    </div>
  );
};

export default ChooseSizeDiamondPhotoMosaic;
